import { Box, InputAdornment, useTheme } from '@mui/material'
import React, { useCallback } from 'react'
import CustomTextField from '../../pages/login/graphicComponents/CustomTextField'

export const INDIA_COUNTRY_CODE = '91'
const INDIA_MOBILE_PATTERN = /^[6-9]\d{9}$/
const INDIA_MOBILE_VALIDATION_ERROR = 'Enter a valid Indian mobile number'

export const isValidIndiaMobileNumber = (mobile: string): boolean => INDIA_MOBILE_PATTERN.test(mobile)

const getIndiaMobileValidationError = (mobile: string): string | null => {
    if (mobile.length === 10 && !isValidIndiaMobileNumber(mobile)) {
        return INDIA_MOBILE_VALIDATION_ERROR
    }
    return null
}

export const formatIndiaMobile = (mobile: string): string => `+${INDIA_COUNTRY_CODE}-${mobile}`

type Props = {
    value: string
    onChange: (phone: string) => void
}

export const PhoneInput: React.FC<Props> = ({ value, onChange }) => {
    const theme = useTheme()
    const inputFontSize = theme.typography.body1.fontSize
    const validationError = getIndiaMobileValidationError(value)

    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const digitsOnly = event.target.value.replace(/\D/g, '').slice(0, 10)
        onChange(digitsOnly)
    }, [onChange])

    return (
        <CustomTextField
            fullWidth
            autoFocus
            placeholder="Mobile Number"
            value={value}
            onChange={handleChange}
            type="tel"
            error={!!validationError}
            helperText={validationError ?? undefined}
            inputProps={{ inputMode: 'numeric', maxLength: 10 }}
            sx={{
                '.MuiInputBase-input': {
                    fontSize: inputFontSize,
                    fontWeight: 400,
                    paddingLeft: '2px'
                }
            }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start" sx={{ mr: 1, height: 'auto', maxHeight: 'none' }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.75,
                                pr: 1.5,
                                fontSize: inputFontSize,
                                fontWeight: 400,
                                lineHeight: 1.4375,
                                color: 'text.primary'
                            }}
                        >
                            <Box component="span" aria-hidden="true">🇮🇳</Box>
                            <Box component="span">+{INDIA_COUNTRY_CODE}</Box>
                        </Box>
                    </InputAdornment>
                )
            }}
        />
    )
}
